import React, { useEffect, useMemo, useState } from "react";
import objectPath from "object-path";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
// Import Layout components
import { Header } from "./header/Header";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Aside } from "./aside/Aside";
import { Footer } from "./footer/Footer";
import { LayoutInit } from "./LayoutInit";
import { SubHeader } from "./subheader/SubHeader";
import { QuickPanel } from "./extras/offcanvas/QuickPanel";
import { QuickUser } from "./extras/offcanvas/QuickUser";
import { ScrollTop } from "./extras/ScrollTop";
import { useSelector } from "react-redux";
import { useAside } from "./AsideContext";
import KTLayoutAsideToggle from "../../_assets/js/layout/base/aside-toggle";
// import { StickyToolbar } from "./extras/StickyToolbar";

export function Layout({ children }) {
  const { language: authLanguage } = useSelector((state) => state.auth);
  const language = localStorage.getItem("language") || authLanguage || "english";
  const { showProductsLayout } = useSelector((state) => state.products);
  const { isAsideOpen, toggleAside } = useAside();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const uiService = useHtmlClassService();
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      desktopHeaderDisplay: objectPath.get(uiService.config, "header.self.fixed.desktop"),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);

  let conditionForMarginTop =
    window?.location?.pathname?.includes("sales") ||
    window?.location?.pathname?.includes("report") ||
    window?.location?.pathname?.includes("invoices");

  const hideLayoutRoutes = ["/stores/edit", "/stores/add"]; // add more if needed

  const shouldHideLayout = hideLayoutRoutes.some((route) => window?.location.pathname.startsWith(route));

  return layoutProps.selfLayout !== "blank" ? (
    <>
      {/*begin::Main*/}
      {!shouldHideLayout && showProductsLayout && <HeaderMobile />}
      <div className="d-flex flex-column flex-root">
        {/*begin::Page*/}
        <div className="d-flex flex-row flex-column-fluid page">
          {layoutProps.asideDisplay && !shouldHideLayout && showProductsLayout && <Aside />}
          {/*begin::Wrapper*/}
          <div
            className={`d-flex flex-column flex-row-fluid wrapper`}
            id="kt_wrapper"
            style={{
              paddingRight: language === "arabic" && isAsideOpen && !isMobile ? "265px" : "0px",
            }}
          >
            {!shouldHideLayout && showProductsLayout && <Header />}
            {/*begin::Content*/}
            <div
              style={{
                paddingRight: language === "arabic" && !isAsideOpen && !isMobile ? "70px" : "0px",
              }}
              onClick={(e) => {
                if (isAsideOpen) {
                  e.preventDefault();
                  toggleAside();
                  KTLayoutAsideToggle.getToggle().toggle();
                }
              }}
              id="kt_content"
              className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid ${!conditionForMarginTop &&
                "main-content-container-margin-top"} ${conditionForMarginTop && "content-with-date-header-margin "} `}
            >
              {layoutProps.subheaderDisplay && !shouldHideLayout && showProductsLayout && <SubHeader />}
              {/*begin::Entry*/}
              {!layoutProps.contentExtended && (
                <div className="d-flex flex-column-fluid">
                  {/*begin::Container*/}
                  <div className={layoutProps.contentContainerClasses}>{children}</div>
                  {/*end::Container*/}
                </div>
              )}

              {layoutProps.contentExtended && { children }}
              {/*end::Entry*/}
            </div>
            {/*end::Content*/}
            {!shouldHideLayout && showProductsLayout && <Footer />}
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Page*/}
      </div>
      <QuickUser />
      <QuickPanel />
      <ScrollTop />
      {/* <StickyToolbar/> */}
      {/*end::Main*/}
      <LayoutInit />
    </>
  ) : (
    // BLANK LAYOUT
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
